/*
 *   Copyright (c) 2022 Luxembourg Institute of Science and Technology
 *   All rights reserved.
 *   See License in the LICENSE file
 */
import * as React from "react";
import logo from "../../assets/logos/logo-white.svg";
import "./header.scss";

export interface HeaderProps {
  type?: "browse" | "contribute" | "boost";
}

const Header = ({ type = "browse" }: HeaderProps) => {
  function getText(type: string) {
    switch (type) {
      case "contribute":
        return "Contribute";
      case "boost":
        return "Boost your practices";
      default:
        return "Browse our Teaching Materials";
    }
  }

  return (
    <div className={"bg-header top-0 relative " + type}>
      <a
        href="https://www.fairnessinteaching-project.eu"
        className="block relative top-[15px] md:pl-[20px]  w-full h-full mx-auto max-md:pr-[10px]"
      >
        <img className="h-[calc(80%-15px)] max-lg:mx-auto lg:my-auto" src={logo} alt="Logo" />
      </a>
      <div className="absolute top-[33%] text-center w-full">
        <h2 className="lg:text-6xl max-lg:hidden mx-auto">{getText(type)}</h2>
      </div>
    </div>
  );
};

export default Header;
